<template>
    <div id="home">
        <top></top>
        <div class="mian" :style="{ height: mianH + 'px' }">
            <left></left>
            <div id="novel_main">
                <novelLongSeries ref="novelLongSeries" @refreshList="refreshList"/>
            </div>

        </div>
        <loadingStatus v-if="loading" />
    </div>
</template>

<script>
import top from '@/components/top.vue' //顶部
import left from '@/components/left.vue' //左侧
import novelLongSeries from '@/components/long_novel/novel_long_series.vue' //分卷管理
import loadingStatus from '@/components/loading_status.vue' //加载
import { EncryptionUtil } from '@/utils/encrypt'
export default {
    components: {
        top, left, novelLongSeries, loadingStatus
    },
    data() {
        return {
            mianH: 0,//主题区域宽度
            loading: true, //加载
            novelInfo: null,
            pageNum: 1,
            successNovelId: '',
        }
    },
    created() {
        this.pageNum = this.$route.query?.pageNum || 1
        this.novelInfo = this.$route.query?.novelInfo ? EncryptionUtil.decrypt(this.$route.query.novelInfo) : {}
        this.successNovelId = this.$route.query?.successNovelId || ''
        this.getList()
    },
    mounted() {
        this.calculateMianHeight();
        window.addEventListener('resize', this.calculateMianHeight);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.calculateMianHeight);
    },
    methods: {
        calculateMianHeight() {
            this.mianH = window.innerHeight - 63;
        },
        getList() {
            if (this.successNovelId) {
                //分卷列表
                console.log('进入分卷列表=', this.novelInfo)
                this.$nextTick(() => {
                    if (this.$refs.novelLongSeries) {
                        console.log('执行分卷列表接口')
                        this.$refs.novelLongSeries.getChapterList(this.novelInfo, Number(this.pageNum))
                    }
                })
                this.loading = false
            }
        },
        refreshList() {
              this.getList()
        }
    }
}
</script>

<style>
#novel {
    width: 100%;
    height: 100vh;
    display: flex;
    flex-flow: column;
}

.mian {
    display: flex;
    min-width: 1500px;
}
</style>